import { PropsWithChildren } from 'react';
import { LiaTimesSolid, LiaCheckSolid } from 'react-icons/lia';

type Props = {
  error?: string;
  success?: boolean;
};

const InputErrorLabels = ({ error, success }: Props) => {
  return (
    <div className="absolute inset-y-0 right-0 flex items-center pr-[16px]">
      {error && (
        <LiaTimesSolid
          aria-hidden="true"
          className="text-gdt-status-red"
          data-testid="error-icon"
        />
      )}
      {success && (
        <LiaCheckSolid
          aria-hidden="true"
          className="text-gdt-status-green"
          data-testid="success-icon"
        />
      )}
    </div>
  );
};

const InputErrorLabel = ({
  children,
  id,
}: PropsWithChildren<{ id?: string }>) => {
  return (
    <p className="text-xs font-medium text-gdt-status-red" id={id} role="alert">
      {children}
    </p>
  );
};

const InputError = {
  Icons: InputErrorLabels,
  Label: InputErrorLabel,
};

export default InputError;
